import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Card, CardActions } from "material-ui/Card";
import { NavigationArrowBack } from "material-ui/svg-icons";
import ContentSave from 'material-ui/svg-icons/content/save';

import FieldTitle from 'util/FieldTitle';

import * as utils from './utils';
import * as urls from "./urls";
import ViewTitle from "components/layout/ViewTitle";
import Toolbar from "components/form/Toolbar";
import connect from "react-redux/es/connect/connect";
import { changeDeliveryStatusRequest as changeDeliveryStatusRequestAction } from "actions/advancedFunction";


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};

class NowOchaChangeMappingStatus extends Component {
  state = {
    status: 3,
  };

  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.setStatus = this.setStatus.bind(this);
    this.handlechangeDeliveryStatusRequest = this.handlechangeDeliveryStatusRequest.bind(this);
  }

  setStatus(status) {
    this.setState({
      status: status,
    });
  }

  goBack() {
    this.props.history.push(urls.nowOchaShopsFrontendPath);
  }

  handlechangeDeliveryStatusRequest() {
    const { record } = this.props;
    const data = {
      shop_id: record.shop_id,
      restaurant_id: record.restaurant_id,
      status: this.state.status,
    };
    this.props.dispatch(changeDeliveryStatusRequestAction(data));
  }

  componentDidMount() {
    const { record } = this.props;
    if (record) {
      this.setStatus(record.status);
    }
  }

  render() {
    const { record } = this.props;
    if (!record) {
      return (
        <Redirect to={urls.nowOchaShopsFrontendPath}/>
      );
    }

    return (
      <div className="list-page">
        <Card>
          <CardActions style={cardActionStyle}>
            <FlatButton
              primary label={'Back'}
              onClick={this.goBack}
              icon={<NavigationArrowBack/>}
            />
          </CardActions>

          <ViewTitle title="Change Status" />

          <div style={{padding: '20px'}}>
            <TextField
              disabled={true}
              floatingLabelText={'Ocha Shop ID'}
              value={record.shop_id || '-'}
            />
            <br/>
            <TextField
              disabled={true}
              floatingLabelText={'Ocha Shop Name'}
              value={record.name || '-'}
            />
            <br/>
            <TextField
              disabled={true}
              floatingLabelText={'Now Restaurand ID'}
              value={record.restaurant_id || '-'}
            />
            <br/>
            <TextField
              disabled={true}
              floatingLabelText={'Now Restaurand ID'}
              value={record.restaurant_name || '-'}
            />
            <br />

            <SelectField
              value={this.state.status}
              floatingLabelText={
                <FieldTitle label={'Status'} />
              }
              onChange={(event, index, value) => {
                this.setStatus(value);
              }}
              autoWidth
            >
              {utils.DELIVERY_STATUS_CHOICES.map((choice) => {
                return (
                  <MenuItem
                    key={choice.id}
                    primaryText={choice.name}
                    value={choice.id}
                  />
                );
              })}
            </SelectField>
          </div>

          <Toolbar>
            <RaisedButton
              // disabled={this.state.has_now_delivery === !!record.has_now_delivery}
              label={'Save'}
              icon={<ContentSave />}
              type='submit'
              primary={true}
              onClick={this.handlechangeDeliveryStatusRequest}
              style={{
                margin: '10px 24px',
                position: 'relative',
              }}
            />
          </Toolbar>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    record: state.admin.recordSelected[utils.NowOchaShopResourceName],
  };
}

export default (
  connect(mapStateToProps)(
    NowOchaChangeMappingStatus
  )
);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/NowOchaChangeMappingStatus.js